// extracted by mini-css-extract-plugin
export default {"message":"chatbot-message_message__jwQLd","darker":"chatbot-message_darker__trpqd","text":"chatbot-message_text__bY8yG","time":"chatbot-message_time__XBn0m"};